'use client';

import { c as _c } from "react/compiler-runtime";
import UserCoOwnedWorlds from '@/app/[locale]/(worlds)/profile/components/UserCoOwnedWorlds';
import UserMyContentSection, { PRIVATE_CONTENT_SECTIONS } from '@/app/[locale]/(worlds)/profile/components/UserMyContentSection';
type UserAllWorldsProps = {
  stopSetAsFeatured: boolean;
};
function UserAllWorlds(t0) {
  const $ = _c(7);
  const {
    stopSetAsFeatured
  } = t0;
  let t1;
  if ($[0] !== stopSetAsFeatured) {
    t1 = PRIVATE_CONTENT_SECTIONS.map(section => <UserMyContentSection key={section.contentTypeCode} {...section} stopSetAsFeatured={stopSetAsFeatured} />);
    $[0] = stopSetAsFeatured;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== stopSetAsFeatured) {
    t2 = <UserCoOwnedWorlds stopSetAsFeatured={stopSetAsFeatured} />;
    $[2] = stopSetAsFeatured;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex scroll-mt-40 flex-col gap-10 px-4 md:px-8 lg:px-18">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export default UserAllWorlds;